import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
  html, body, div, span, applet, object, iframe, h1, h2, h3, h4, h5, h6, blockquote, pre, a, abbr, acronym, address, big, cite, code, del, dfn, em, img, ins, kbd, q, s, samp, small, strike, strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td, article, aside, canvas, details, embed, figure, figcaption, footer, header, hgroup, menu, nav, output, ruby, section, summary, time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }

  article, aside, details, figcaption, figure, footer, header, hgroup, menu, nav, section {
    display: block;
  }

  p {
    line-height: 1.25;
  }

  a {
    text-decoration: none;
  }

  a:visited,
  a:active {
    color: inherit;
  }

  body {
    font-family: 'Noto Sans Display', sans-serif;
    line-height: 1;
  }

  .flex-col {
    display: flex;
    flex-direction: column;
  }

  .flex-row {
    display: flex;
    flex-direction: row;
  }

  .item-center {
    align-items: center;
    display: flex;
  }

  ol, ul {
    list-style: none;
  }

  blockquote, q {
    quotes: none;
  }

  blockquote:before,
  blockquote:after {
    content: '';
    content: none;
  }

  q:before,
  q:after {
    content: '';
    content: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  *,
  ::before,
  ::after {
    box-sizing: border-box;
  }

  h1 {
    ${StyleGuide.tipografia.titulo1};
  }

  h2 {
    ${StyleGuide.tipografia.titulo2};
    @media(min-width: ${StyleGuide.mediaQuery.mobile}) {
      font-size: 22px;
    }
    @media (min-width: 520px) {
      font-size: 20px;
    }
    @media (min-width: 565px) {
      font-size: 22px;
    }
  }

  h3 {
    ${StyleGuide.tipografia.titulo3};
    font-size: 16px;
    @media(min-width: ${StyleGuide.mediaQuery.mobile}) {
      font-size: 18px;
    }
  }

  p {
    ${StyleGuide.tipografia.textoPequeno};
    font-family: 'Noto Sans Display', sans-serif;
  }

  strong {
    font-family: 'Noto Sans Display';
    font-weight: 600;
  }

  input {
    box-shadow: none;
  }

  .card--modal {
      overflow-y: auto;
      margin-top: 20px
      max-height: 80%;
      display: block;
      > div {
        height: 100%;
        justify-content: center;

      }
    }
  @media(max-width: ${StyleGuide.mediaQuery.tablet}) {
    .card--modal {
      overflow-y: auto;
      height: auto;
      max-height: 80%;
      > div {
        height: 100%;
        justify-content: center;

      }
    }
  }

  @media(min-width: ${StyleGuide.mediaQuery.smallpc}) {
    .menu {
      position: fixed;
      left: 0;
    }

    #root {
      /* height: 100vh; */
      overflow: hidden;
    }

    main {
      height: 100%;
      /* ${( { isAssociadoLogado } ) => isAssociadoLogado && 'overflow-y: scroll;'} */
    }
  }
`

export default GlobalStyle
